import styled from 'styled-components';

import { Button, maxWidth, units } from '@calm-web/design-system';

import AmazonLogo from 'icons/amazon_icon.svg';

export const HeaderDiv = styled.div`
	height: 100px;
	padding-top: 25px;
`;

export const Content = styled.div`
	margin: 0 auto;
	display: flex;
	justify-content: space-between;
	max-width: 1300px;
	height: 100%;
	line-height: 100px;
	padding: 0 ${units(2.5)};
	position: relative;
`;

export const Amazon = styled(AmazonLogo)`
	height: 20px;
	width: 20px;
	${maxWidth('desktop')} {
		transform: scale(0.7);
	}
`;

export const PurchaseButton = styled(Button).attrs({
	Icon: Amazon,
	backgroundColor: 'buttonPrimaryBg',
})`
	float: right;
	${maxWidth('desktop')} {
		transform: scale(0.7);
	}
`;
